/**
 * F60b — "From cache" / "N MB scanned" under the ops pages' controls. Logs
 * Insights bills per GB scanned, so both pages show what a load cost.
 */
import { useI18n } from '@bravemove/i18n/react';
import type { OpsLogsScanMeta } from '@bravemove/types';
import { megabytes } from './opsHelpers';

export function ScanMeta({ meta }: { readonly meta: OpsLogsScanMeta }) {
  const { t } = useI18n();
  return (
    <span className="text-[12.5px] text-ink-3">
      {meta.cached
        ? t('admin:opsLogs.table.cached')
        : t('admin:opsLogs.table.scanned', { mb: megabytes(meta.bytesScanned) })}
    </span>
  );
}
